// extracted by mini-css-extract-plugin
export default {"loclIcon":"LanguageSwitcher_loclIcon__ynfZs","loclIconActive":"LanguageSwitcher_loclIconActive__0orgX","icon":"LanguageSwitcher_icon__oifB+","block":"LanguageSwitcher_block__7Vx2A"};